<template>
  <v-container fluid class="mt-3 pr-8">
    <p class="text-h6 font-weight-light">{{ user.name + ' ' + user.lastname + ' (' + user.username + ')' }}<v-spacer></v-spacer>
    </p>

    <!--    ROLES TABLE VIEW    -->
    <v-row>
      <v-col>
        <v-progress-linear indeterminate v-show="loading"></v-progress-linear>

        <v-data-table
          :headers="headers"
          :items="userRoles"
          item-key="userRoleId"
          class="elevation-1 grey lighten-3"
          v-bind:no-data-text="$t('noRoles')"
          v-bind:no-results-text="$t('noRoles')"
          :footer-props="{
            showFirstLastPage: true,
            'items-per-page-text': $t('rowsPerPage'),
          }"
        >
          <!--    Table toolbar    -->
          <template v-slot:top>
            <v-toolbar flat dark color="#2b5d66">
              <v-toolbar-title>{{ $t('userRole') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <!-- New dialog -->
              <v-dialog
                v-model="dialog"
                width="1000px"
                persistent
              >             
                <template v-slot:activator="{ on, attrs }">
                  
                  <v-btn v-bind="attrs"
                    v-on="on"
                    outlined>
                    <v-icon
                      left
                      dark
                    >
                    group_add
                    </v-icon>
                    {{ $t('addRole') }}
                 </v-btn>
                    
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">{{ $t('addRole') }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                    <v-form
                    ref="addRoleForm">
                      <v-row>
                        <v-col
                          cols="12"
                          sm="10"
                          md="6"
                        >
                          <v-select 
                          v-model="newRole.organizationId"
                          :items="organizations"
                          :rules="[v => !!v || '!']"
                          item-text="name"
                          item-value="organizationId"
                          v-bind:label="$t('organization') + '*'"
                          v-bind:no-data-text="$t('noData')"
                          @change="getRoles()"
                          >
                          </v-select>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="10"
                          md="6"
                        >
                          <v-select 
                          v-model="newRole.roleIds"
                          :items="roles"
                          :rules="[v => !!v || '!']"
                          item-text="description"
                          item-value="roleId"
                          v-bind:label="$t('role') + '*'"
                          v-bind:no-data-text="$t('noData')"
                          multiple
                          >
                          </v-select>
                        </v-col>
                      </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="close"
                    >
                      {{ $t('cancel') }}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="addRole"
                    >
                      {{ $t('save') }}
                    </v-btn>
                  </v-card-actions>
                </v-card>                
              </v-dialog>
            </v-toolbar>
          </template>

          <!-- Custom HEADER -->
          <template v-for="h in headers" v-slot:[`header.${h.value}`]="{ header }">
            {{ $t(header.text) }} 
          </template>

          <!--  Change of pagination. Put 'od' instead 'of'  -->
          <template v-slot:[`footer.page-text`]="items">
            {{ items.pageStart }} - {{ items.pageStop }} {{ $t('of') }}
            {{ items.itemsLength }}
          </template>
          
          <!--  Actions  -->
          <template v-slot:[`item.actions`]="{ item }" width="10%">
            <v-row>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    class="mr-3"
                    color="error"
                    @click.stop.prevent="deleteRole(item)"
                  >
                    delete
                  </v-icon>
                </template>
                <span>{{ $t('delete') }}</span>
              </v-tooltip>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "UserRole",
  components: {},
  props: ['user'],
  data() {
    return {
        userRoles: [],
        loading: false,
        headers: [
            {
                text: "organization",
                sortable: true,
                value: "organization"
            },
            {
                text: "role",
                sortable: true,
                value: "description"
            },
            {
                text: "actions",
                sortable: false,
                value: "actions",
                width: 1
            }
          ],
          newRole: {
            userId: this.user.userId,
            organizationId: "",
            roleIds: []
          },
          dialog: false,
          organizations: [],
          roles: []
        }
  },
  created() {
    this.getUserRole();
    this.getOrganizations();
  },
  computed: {
    loggedUser() {
        return this.$store.getters.loggedUser;
    },
  },
  methods: {
    getUserRole() {
        this.loading = true;
        if(this.user != null) {
          this.axios.get('User/UserRole?userId=' + this.user.userId).then((response) => {
          this.userRoles = response.data;
          this.loading = false;
            })
            .catch(err => console.log(err));
        }
        else {
            this.$router.push({ name: 'Users', replace: false});
        }        
    },
    addRole() {
        if(this.validation()) {
          console.log('newRoleIds')
          console.log(this.newRole)
          this.axios.post('User/AddUserRole', this.newRole ).then((response) => {
            if(response && response.status === 200) {
              this.getUserRole();
              this.close();
              this.$root.displayNotificationMsg(this.$t('saved'), 'success')
            }
          })
          .catch((error) => {
              if (error.response) {
                  console.log(error.response.data);
                  console.log(error.response.status);
                  this.$root.displayNotificationMsg(error.response.data, 'warning')
              }
              else if (error.request) {
                  console.log(error.request);
              } 
          })
        }
        else {
          this.$root.displayNotificationMsg(this.$t('dataRequired'), 'warning')
      }
    },
    validation() {
      return this.$refs.addRoleForm.validate();
    },
    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.newRole.organizationId = "";
        this.newRole.roleIds = [];
      })
    },
    getOrganizations() {
      this.axios.get('Organization/GetUserOrganization?userId=' + this.user.userId).then((response) => {
          this.organizations = response.data;
          if(this.organizations.length === 1) {
            this.newRole.organizationId = this.organizations[0].organizationId;
            this.getRoles();
          }
        })
        .catch(err => console.log(err));
    },
    getRoles() {
        this.axios.get('User/NotAssignedOrganizationRole?userId=' + this.user.userId + '&organizationId=' + this.newRole.organizationId).then((response) => {
          this.roles = response.data;
        })
        .catch(err => console.log(err));
    },
    async deleteRole(item) {
      if(await this.$confirm(this.$t('deleteUserRoleMessage'), { title: this.$t('warning'), buttonTrueText: this.$t('yes'), buttonFalseText: this.$t('no'), persistent: true })) {
        this.axios.delete('User/DeleteUserRole?userRoleId=' + item.userRoleId).then((response) => {
          if(response.status === 200) {
            this.getUserRole();
            this.$root.displayNotificationMsg(this.$t('deleted'), 'success')
          }
        })
        .catch(err => {
          console.log(err)
          console.log(err.response.data)
          this.$root.displayNotificationMsg(this.$t('deleted'), 'error')
        });  
      }
    }
  }
};
</script>

<style scoped>
</style>